import { useEffect, useState } from "react";
import InterviewPreviewHeader from "../../Interview/ViewInterview/InterviewPreviewHeader";
import { useGeneralContext } from "../../General/Context";
import { GlobalService } from "../../../services/GlobalService";
import { useTranslation } from "react-i18next";
import RoleInformationSection from "../../Interview/ViewInterview/RoleInformationSection";
import ThreeDotsDropDownMibilityInternational from "./ThreeDotsDropDownMibilityInternational";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import InterviewTabSection from "../../Interview/ViewInterview/InterviewTabSection";
import ShareInterviewModal from "./ShareInterviewModal";
import Recommended from "../Recommended/Recommended";
import { toast } from "react-toastify";
import { InterviewService } from "../../../services/InterviewService";

export default function InterviewDetailsPage({ match }) {
  const [interview, setInterview] = useState();
  const { t } = useTranslation();
  const { userInformation } = useGeneralContext();
  const [selectedCompany, setSelectedCompany] = useState();
  const [isOpenShareInterview, setIsOpenShareInterview] = useState(false);
  const [isOpenShareToManager, setIsOpenShareToManager] = useState(false);
  const [recommendedInterview, setRecommendedInterview] = useState({
    usersRecommendedBy: [],
    comment: ""
  });
  const [newInterviewId, setNewInterviewId] = useState();

  let history = useHistory();

  useEffect(() => {
    GlobalService.getInterviewDetails(match.params.id).then((data) => {
      setInterview(data);
    });
  }, []);
  useEffect(() => {
    if (newInterviewId) {
      setIsOpenShareToManager(true);
    }
  }, [newInterviewId]);

  const getRecommendedByValue = () => {
    if (recommendedInterview?.usersRecommendedBy.length > 0) {
      return recommendedInterview.usersRecommendedBy
        .map((user) => user.recommendedBy ?? "")
        .join(" | ");
    } else {
      return "";
    }
  };

  function goBack() {
    if (match.params.searchTerm)
      history.push(`/global/candidates/${match.params.searchTerm}`);
    else history.push("/global/candidates");
  }

  function createInterviewInOtherCompany(request) {
    setSelectedCompany(request.destinationComapnyId);
    GlobalService.createInterviewInOtherCompany(request).then((data) => {
      if (!data.error) {
        setIsOpenShareInterview(false);
        toast.success(t("Interview created successfully in the other company"));
        setNewInterviewId(data);
      }
    });
  }

  function toggleFavorite() {
    if (interview.favorite) {
      InterviewService.deleteFavorite(interview.interviewId).then(() => {
        setInterview({ ...interview, favorite: false });
      });
    } else {
      InterviewService.addFavorite(interview.interviewId).then(() => {
        setInterview({ ...interview, favorite: true });
      });
    }
  }

  return (
    <>
      {interview && (
        <>
          <InterviewPreviewHeader
            interview={interview}
            userInformation={userInformation}
          >
            <div className="text-end col-auto">
              <a
                href="#!"
                className="btn app-button btn-second btn-lg"
                onClick={goBack}
              >
                {t("Back")}
              </a>
            </div>
          </InterviewPreviewHeader>
          <RoleInformationSection
            interview={interview}
            recommendedManagers={[]}
            availabilityListStatus={[]}
            getRecommendedByValue={getRecommendedByValue}
            toggleFavorite={toggleFavorite}
          >
            <ThreeDotsDropDownMibilityInternational
              interview={interview}
              openCreateInterviewInOtherCompany={() => {
                setIsOpenShareInterview(true);
              }}
            />
          </RoleInformationSection>
          <InterviewTabSection
            interview={interview}
            id={match.params.id}
          ></InterviewTabSection>
          <ShareInterviewModal
            isOpen={isOpenShareInterview}
            onClose={() => setIsOpenShareInterview(false)}
            interviewId={match.params.id}
            createInterviewInOtherCompany={createInterviewInOtherCompany}
          />
          <Recommended
            isOpenRecommendForm={isOpenShareToManager}
            closeForm={() => setIsOpenShareToManager(false)}
            interviewId={newInterviewId}
            companyId={selectedCompany}
          />
        </>
      )}
    </>
  );
}
